'use client';

import { useState, useEffect } from 'react';
import ListingCard from '@/components/ui/cards/listing';
import Button from '@/components/ui/button';

export default function ExploreListings({
  location,
  types,
  departureDate,
  returnDate,
}) {
  const [list, setList] = useState(12);
  const [boats, setBoats] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [userLat, setUserLat] = useState(null);
  const [userLong, setUserLong] = useState(null);
  const burl = `${process.env.NEXT_PUBLIC_API}`;
  const GOOGLE_API_KEY = process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY;

  let userid = null;
  try {
    if (typeof window !== 'undefined') {
      userid = sessionStorage.getItem('userId');
    }
  } catch (error) {
    console.error('sessionStorage is not available during build:', error);
  }

  // Convert address to geolocation if location is provided
  useEffect(() => {
    async function getGeolocation(address) {
      try {
        const response = await fetch(
          `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
            address,
          )}&key=${process.env.NEXT_PUBLIC_GOOGLE_MAP_API_KEY}`,
        );

        const data = await response.json();
        if (data.status === 'OK' && data.results.length > 0) {
          const { lat, lng } = data.results[0].geometry.location;
          setUserLat(lat);
          setUserLong(lng);
        } else {
          console.error('Geolocation not found for address:', address);
        }
      } catch (error) {
        console.error('Error fetching geolocation:', error);
      }
    }

    if (location) {
      getGeolocation(location);
    } else if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setUserLat(position.coords.latitude);
          setUserLong(position.coords.longitude);
        },
        (error) => {
          console.error('Error getting location:', error);
        },
      );
    } else {
      console.error('Geolocation is not supported by this browser.');
    }
  }, [location]);

  useEffect(() => {
    async function fetchBoats() {
      if (userLat === null || userLong === null) return;

      try {
        const response = await fetch(`${burl}/getlistallrentals.php`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            userid,
            userlat: userLat,
            userlong: userLong,
            startdate: departureDate,
            enddate: returnDate,
            types,
          }),
        });

        if (!response.ok) {
          throw new Error('Failed to fetch boats data');
        }

        const data = await response.json();
        setBoats(data.records || []);
      } catch (error) {
        console.error('Error fetching boats data:', error);
      }
    }

    fetchBoats();
  }, [userLat, userLong, burl]);

  function handleLoadMore() {
    setIsLoading(true);
    setTimeout(() => {
      setList((prevList) => prevList + 10);
      setIsLoading(false);
    }, 600);
  }

  return (
    <div>
      <div className="mt-1 grid grid-cols-1 gap-x-5 gap-y-8 xs:grid-cols-2 lg:grid-cols-3 3xl:gap-y-10 4xl:grid-cols-4">
        {boats.slice(0, list).map((item, index) => (
          <ListingCard
            key={`explore-boat-${index}`}
            id={`explore-boat-${index}`}
            type={item.title}
            slides={item.Thumb}
            time={item.time}
            caption={item.address}
            title={item.title}
            slug={item.id}
            location={item.location}
            price={item.price}
            priceh={item.priceh}
            ratingCount={item.ratingCount}
            rating={item.rating}
          />
        ))}
      </div>
      {boats.length >= list && (
        <Button
          size="xl"
          type="button"
          isLoading={isLoading}
          onClick={handleLoadMore}
          className="relative bottom-0 left-1/2 z-30 mx-auto mt-16 -translate-x-1/2 px-6 py-2.5 md:sticky md:bottom-10 md:text-base xl:relative xl:bottom-0"
        >
          Load more
        </Button>
      )}
    </div>
  );
}
